import { render, staticRenderFns } from "./podcast.vue?vue&type=template&id=447a71c7&scoped=true"
import script from "./podcast.vue?vue&type=script&lang=js"
export * from "./podcast.vue?vue&type=script&lang=js"
import style0 from "./podcast.vue?vue&type=style&index=0&id=447a71c7&prod&scoped=true&lang=sass"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "447a71c7",
  null
  
)

export default component.exports